module.exports = __webpack_public_path__ + "static/media/logo-zoo.969b66c8.png";